'use strict'
var _interopRequireDefault = require('@babel/runtime/helpers/interopRequireDefault')
require('core-js/modules/es.array.concat')
require('core-js/modules/es.array.fill')
require('core-js/modules/es.array.for-each')
require('core-js/modules/es.array.join')
require('core-js/modules/es.regexp.exec')
require('core-js/modules/es.string.replace')
require('core-js/modules/es.string.split')
require('core-js/modules/web.dom-collections.for-each')
exports.__esModule = true
exports.default = void 0
var _createClass2 = _interopRequireDefault(require('@babel/runtime/helpers/createClass'))
var _assertThisInitialized2 = _interopRequireDefault(
  require('@babel/runtime/helpers/assertThisInitialized')
)
var _inheritsLoose2 = _interopRequireDefault(require('@babel/runtime/helpers/inheritsLoose'))
var _defineProperty2 = _interopRequireDefault(require('@babel/runtime/helpers/defineProperty'))

var _is = require('../is')
var _utils = require('./utils')
var _inherent = _interopRequireDefault(require('./inherent'))

var firstDregex = /^d/
var validStrRegex = /^d(0|1){7}$/

/* eslint-disable class-methods-use-this */

/**
 * DaysVal
 *
 *
 * @class DayVal
 * @extends {Inherent}
 * @implements {ValsInterface}
 */ var DayVal = /*#__PURE__*/ (function(_Inherent) {
  ;(0, _inheritsLoose2.default)(DayVal, _Inherent)
  function DayVal() {
    var _this
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key]
    }
    _this = _Inherent.call.apply(_Inherent, [this].concat(args)) || this
    ;(0, _defineProperty2.default)(
      (0, _assertThisInitialized2.default)(_this),
      'name',

      'day'
    )
    return _this
  }
  var _proto = DayVal.prototype

  /**
   * @param {ValidStrType} str d0010100
   * @returns {ValidValType} [ 2, 4 ]
   * @memberof DayVal
   *
   */ _proto.parseStr = function parseStr(str) {
    var result = []
    str
      .replace(firstDregex, '')
      .split('')
      .forEach(function(dayVal, ind) {
        if (dayVal === '1') {
          result.push(ind)
        }
      })
    return result
  }

  /**
   * @param {ValidValType} daysArr [ 0, 3, 4, 5 ]
   * @returns {ValidStrType} d1001110
   * @memberof DayVal
   */
  _proto.stringify = function stringify(daysArr) {
    var result = new Array(7).fill(0)
    daysArr.forEach(function(dayInd) {
      result[dayInd] = 1
    })
    return 'd' + result.join('')
  }
  _proto.validateStr = function validateStr(str) {
    return (0, _is.isStr)(str) && validStrRegex.test(str) ? str : null
  }
  _proto.validateVal = function validateVal(val) {
    return (0, _utils.validateNumsArr)(val, 6) ? val : null
  }
  ;(0, _createClass2.default)(DayVal, [
    {
      key: 'isAny',
      get: function get() {
        return (0, _utils.isAnyDefault)(this._val, 0, 6)
      }
    }
  ])
  return DayVal
})(_inherent.default)
exports.default = DayVal



//////////////////
// WEBPACK FOOTER
// ./~/hlp/dist/TimingParser/day.js
// module id = 629
// module chunks = 0